// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./private/fonts/sofia-pro-bold/_webfonts/sofiapro_bold_macroman/stylesheet.css
// module id = 345
// module chunks = 0